import { createContext } from 'react';

import type { MelwaysInformation } from './melways-info';

export const MelwaysContext = createContext<MelwaysInformation | null>(null);
